/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

const TotalCount = props => <h2>{props.total}</h2>;

export default TotalCount;
